import { Fragment } from 'react';
import { rage } from '~/rage';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledBgShadowImage, StyledBgShadow } from './Background.styled';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && <BgPlaceholder $type={PlaceholderType.Default} />}
		<StyledBgShadow />
		<StyledBgShadowImage />
	</Fragment>
);

export { Background };
